import React from 'react'
import Tablecontainer from '../../section/Tablecontainer/Tablecontainer'

const Table = () => {
  return (
    <div>
<Tablecontainer/>


    </div>
  )
}

export default Table